import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { ListPagination } from '@components';
import { Trans } from '@libs/i18n';

interface AssessmentPaginationProps {
  page: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  onPageChange: (page: number) => void;
  isLoading: boolean;
}

export const AssessmentPagination: FC<AssessmentPaginationProps> = observer(
  ({ page, totalPages, totalCount, hasNextPage, hasPrevPage, onPageChange, isLoading }) => (
    <ListPagination
      page={page}
      totalPages={totalPages}
      onPageChange={onPageChange}
      isLoading={isLoading}
      hasPrevPage={hasPrevPage}
      hasNextPage={hasNextPage}
      summary={
        <Trans
          i18nKey="app.assessments.pagination.summary"
          values={{ page, totalPages, totalCount }}
        />
      }
    />
  ),
);
